var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
import * as React from 'react';
import IconButton from 'react-toolbox/lib/button/IconButton';
import IconMenu from 'react-toolbox/lib/menu/IconMenu';
import MenuItem from 'react-toolbox/lib/menu/MenuItem';
import { withMedia } from 'react-with-media';
import { Row } from 'styled-material';
export var mediaMobile = '(max-width: 500px)';
export var Menu = withMedia(mediaMobile)(function (_a) {
    var matches = _a.matches,
        items = _a.items,
        forceMenu = _a.forceMenu,
        forceExpanded = _a.forceExpanded,
        _a$limitExpandedItems = _a.limitExpandedItems,
        limitExpandedItems = _a$limitExpandedItems === undefined ? 2 : _a$limitExpandedItems,
        props = __rest(_a, ["matches", "items", "forceMenu", "forceExpanded", "limitExpandedItems"]);

    return !forceExpanded && (forceMenu || matches || items.length > limitExpandedItems) ? React.createElement(IconMenu, Object.assign({ icon: 'more_vert' }, props), items.map(function (item) {
        return React.createElement(MenuItem, Object.assign({ key: item.value }, item));
    })) : React.createElement(Row, { horizontal: 'flex-end' }, items.map(function (item) {
        return React.createElement(IconButton, { key: item.value, icon: item.icon, onClick: item.onClick });
    }));
});
//# sourceMappingURL=menu.js.map
